export default {
  root: {
    marginLeft: 50,
  },
};
